export function InsertArtText (pEditor, pArtText)
{
  this.openInsertArtTextDialog = (pButton) =>
  {
    if (pEditor.extParameters && pEditor.extParameters.artTextState == 1 && pEditor.extParameters.artTextIsDisabledMessage)
    {
      alert(pEditor.extParameters.artTextIsDisabledMessage);
      return;
    }

    var picId,
        selectedHTML,
        selectedText,
        currentRange;

    pEditor.pDialog = (pButton && pButton.getDialog()) ? pButton.getDialog() : BEditor.Dialogs['ArtText'].dialog;

    if (!pEditor.pDialog)
    {
      return false;
    }

    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.setExcludeWordCheck();

    selectedHTML = pEditor.range.content.getHTML();
    selectedText = pEditor.range.content.getText();

    pArtText.currentArtTextPicture = pEditor.image.getCurrentImage() || pEditor.image.currentImage;

    if (pArtText.currentArtTextPicture)
    {
      picId = pArtText.getArtTextImageId(pArtText.currentArtTextPicture);

      if (!BEditor.browser.isIE)
      {
        pArtText.currentArtTextPicture.setAttribute('data-wacurrentarttextpicture', '1');
      }
    }

    if (picId && picId[2].length > 0)
    {
      pEditor.pDialog.setReturnedParameters('editMode', 'edit');
      pEditor.pDialog.setReturnedParameters('picId', picId);
    }
    else
    {
      if (!BEditor.browser.isIE && pEditor.layer.queryStatePositionAbsolute(pButton, null))
      {
        currentRange = pEditor.range.getCurrent();

        if (currentRange)
        {
          currentRange.insertNode(currentRange.createContextualFragment('<span data-wainsertpointer="1"></span>'));
        }
      }

      pEditor.pDialog.setReturnedParameters('editMode', 'new');
      pEditor.pDialog.setReturnedParameters('selectedHTML', selectedHTML);
      pEditor.pDialog.setReturnedParameters('selectedText', selectedText);
      pEditor.pDialog.setReturnedParameters('replaceSelection', (selectedText == selectedHTML));
    }

    pEditor.range.save();

    pEditor.pDialog.openWindow(function() { pEditor.pThis.execCommand(pButton, 'insertArtText'); }, function() { pEditor.closeDialog(pEditor.pDialog); });

    pEditor.afterOpenDialog();
  };


  function insertArtText (pButton)
  {
    var pParameters, sParameters, currentRange, contentToInsert;
    var isChangedPicture = false;
    var isAbsElement = false;
    var artTextElement = false;
    var imgObject;
    var insertPoint;

    if (pEditor.pDialog)
    {
      pParameters = pEditor.pDialog.getReturnedParameters();

      if (pParameters)
      {
        sParameters = {};
        sParameters.artTextImage = pParameters.artTextImage;
        sParameters.text = pParameters.text;
        sParameters.src = pParameters.src;
        sParameters.alt = pParameters.alt;
        sParameters.editMode = pParameters.editMode;
        sParameters.selectedHTML = pParameters.selectedHTML;
        sParameters.replaceSelection = pParameters.replaceSelection;
        sParameters.savedRange = pParameters.savedRange;
      }

      if (!BEditor.browser.isIE && pArtText.currentArtTextPicture && !pArtText.currentArtTextPicture.parentNode)
      {
        pArtText.currentArtTextPicture = pEditor.iFrameDoc.body.querySelector('IMG[data-wacurrentarttextpicture]');
      }

      insertPoint = pEditor.iFrameDoc.body.querySelector('SPAN[data-wainsertpointer]');

      if (insertPoint)
      {
        insertPoint.removeAttribute('data-wainsertpointer');
        insertPoint.setAttribute('data-wainsertpointerforarttext', '1');
      }

      pEditor.closeDialog();

      if (sParameters)
      {
        if (sParameters.artTextImage)
        {
          if (!pArtText.currentArtTextPicture)
          {
            currentRange = pEditor.range.getCurrent();
            contentToInsert = '<img data-newArtTextMark="1" class="artText" src="' + sParameters.src + '" title="' + sParameters.alt + '" alt="' + sParameters.alt + '" border="0"';

            if (pEditor.isEditorInHeader)
            {
              var rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute(true);

              if (!rangeElement)
              {
                contentToInsert += ' style="position: absolute; top: 17px; left: 17px; z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '">';
                isAbsElement = true;
              }
              else if (rangeElement.nodeName.toUpperCase() == 'DIV' && (rangeElement.innerHTML.replace(/(<br>|\s|&nbsp;)/ig, '') == '' || rangeElement.innerHTML == sParameters.selectedHTML))
              {
                contentToInsert += ' style="position: absolute; top: ' + rangeElement.offsetTop + 'px; left: ' + rangeElement.offsetLeft + 'px; z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '">';
                isAbsElement = true;
                rangeElement.parentNode.removeChild(rangeElement);
              }
              else if (rangeElement.nodeName.toUpperCase() == 'IMG')
              {
                changePic(rangeElement);
                isChangedPicture = true;
              }
              else
              {
                contentToInsert += '>';
              }
            }
            else
            {
              contentToInsert += '>';
            }
          }
          else
          {
            changePic(pArtText.currentArtTextPicture);
            isChangedPicture = true;
          }
        }
        else
        {
          currentRange = pEditor.range.getCurrent();

          if (pEditor.isEditorInHeader)
          {
            if (pArtText.currentArtTextPicture)
            {
              if (pEditor.$Style(pArtText.currentArtTextPicture, 'position').toLowerCase() == 'absolute')
              {
                contentToInsert = '<div style="position: absolute; top: ' + pArtText.currentArtTextPicture.offsetTop + 'px; left: ' + pArtText.currentArtTextPicture.offsetLeft + 'px; z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '">' + sParameters.text + '</div>';
                isAbsElement = true;
              }
              else
              {
                contentToInsert = sParameters.text;
              }
            }
            else
            {
              contentToInsert = '<div style="position: absolute; top: 17px; left: 17px; z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '">' + sParameters.text + '</div>';
              isAbsElement = true;
            }
          }
          else
          {
            contentToInsert = sParameters.text;
          }
        }


        if (!isChangedPicture)
        {
          if (!((sParameters.editMode != "new") || (sParameters.replaceSelection && (sParameters.editMode == "new"))))
          {
            contentToInsert += sParameters.selectedHTML;
          }

          if (BEditor.browser.isIE)
          {
            if (sParameters.editMode == "new")
            {
              //TODO:Dime ???!!!
              currentRange = pEditor.range.getCurrent();
              currentRange.pasteHTML(contentToInsert);
            }
            else
            {
              if (pArtText.currentArtTextPicture)
              {
                pArtText.currentArtTextPicture.outerHTML = contentToInsert;
              }
              else
              {
                currentRange.item(0).outerHTML = contentToInsert;
              }
            }
          }
          else
          {
            if (insertPoint)
            {
              insertPoint.outerHTML = contentToInsert;
            }
            else
            {
              currentRange.deleteContents();
              pEditor.contentCleaner.removeEmptyP();
              currentRange.insertNode(currentRange.createContextualFragment(contentToInsert));
            }

            artTextElement = pEditor.iFrameDoc.body.querySelector('[data-newArtTextMark]');

            if (artTextElement)
            {
              artTextElement.removeAttribute('data-newArtTextMark');
              pEditor.range.cursor.show(artTextElement, false);
            }

            if (isAbsElement)
            {
              pEditor.layer.objectFactory.fixAllAbsElements(true);
            }
          }
        }
        else
        {
          imgObject = pEditor.image.objectFactory.getImageObject(pArtText.currentArtTextPicture);

          if (imgObject)
          {
            imgObject.object.select();
          }
        }

        pEditor.image.objectFactory.checkAllImages();
      }

      pEditor.range.save();
    }

    if (pEditor.undoRedo.isStopSaveUndo)
    {
      pEditor.undoRedo.saveUndoDo();
      pEditor.undoRedo.isStopSaveUndo = false;
    }

    function changePic (el)
    {
      el.id = "";
      el.className = "artText";
      el.name = "";
      el.style.width = "";
      el.style.height = "";
      el.src = sParameters.src;
      el.alt = sParameters.alt;
      el.title = sParameters.alt;
    }
  }
  
  
  this.insertArtText = insertArtText;
}